import React, { useState } from "react";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";
import { releaseFeatures } from "@/config/releaseFeatures";

import dynamic from "next/dynamic";
const LangPopup = dynamic(() => import("./LangPopup"));

function Footer() {
  const [showLangs, setShowLangs] = useState(false);
  const { t } = useTranslation("common");
  const linkClass = "text-sm text-slate-300 transition-colors hover:text-white";

  return (
    <footer className="mt-auto w-full bg-altgray-800 text-slate-300">
      {showLangs && <LangPopup setShowLangs={setShowLangs} />}
      <div className="mx-auto grid w-full max-w-6xl gap-10 px-6 pb-8 pt-12 md:grid-cols-[1fr_2fr] md:px-8">
        <div>
          <Link href="/" className="inline-block" aria-label="Chess Hotel">
            <img
              src="/images/logo-white2x.png"
              alt="Chess Hotel"
              className="h-auto w-36"
            />
          </Link>
          <p className="mt-4 max-w-xs text-sm leading-6 text-slate-400">
            {t("Footer tagline")}
          </p>
        </div>

        <nav
          aria-label={t("Footer navigation")}
          className="grid grid-cols-2 gap-8 sm:grid-cols-3"
        >
          <div>
            <h2 className="text-sm font-semibold text-white">{t("Play")}</h2>
            <div className="mt-4 flex flex-col gap-3">
              <Link href="/play" className={linkClass}>
                {t("Play chess")}
              </Link>
              <Link href="/puzzles/themes" className={linkClass}>
                {t("Puzzles")}
              </Link>
              <Link href="/puzzle" className={linkClass}>
                {t("Daily puzzles")}
              </Link>
              <Link href="/puzzles" className={linkClass}>
                {t("Puzzle League")}
              </Link>
            </div>
          </div>

          <div>
            <h2 className="text-sm font-semibold text-white">{t("Learn")}</h2>
            <div className="mt-4 flex flex-col gap-3">
              <Link href={releaseFeatures.learning ? "/openings" : "/learn/openings"} className={linkClass}>
                {t("Openings")}
              </Link>
              {releaseFeatures.learning && <>
              <Link href="/learn/openings" locale={false} className={linkClass}>
                {t("Interactive lessons")}
              </Link>
              <Link href="/guides" locale={false} className={linkClass}>
                {t("Chess guides")}
              </Link>
              </>}
            </div>
          </div>

          <div>
            <h2 className="text-sm font-semibold text-white">{t("Legal")}</h2>
            <div className="mt-4 flex flex-col gap-3">
              <Link
                href="/privacypolicy"
                className={linkClass}
                prefetch={false}
              >
                {t("Privacy policy")}
              </Link>
              <Link
                href="/termsofservice"
                className={linkClass}
                prefetch={false}
              >
                {t("Terms of service")}
              </Link>
            </div>
          </div>
        </nav>
      </div>

      <div className="mx-auto flex w-full max-w-6xl flex-col gap-5 border-t border-white/10 px-6 py-8 sm:flex-row sm:items-center sm:justify-between md:px-8">
        <p className="text-xs text-slate-500">
          © {new Date().getFullYear()} Chess Hotel
        </p>
        <div className="relative w-full sm:w-44">
          <button
            type="button"
            aria-expanded={showLangs}
            onClick={() => {
              setShowLangs(!showLangs);
            }}
            className="h-10 w-full rounded-md border border-white/10 bg-altgray-700 px-3 py-2 text-center text-sm text-slate-300 transition-colors hover:bg-altgray-650 hover:text-white"
          >
            {t("Language")}
          </button>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
